// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OQPk9","importantInfo":"styles_importantInfo__3bYqV"};